import { notifications } from '@mantine/notifications';
import { signup } from '../../apiClient';
import { useAuthStore } from '../../../store';
import { useMutation } from '@tanstack/react-query';

const useSignup = () => {
    const setAuthToken = useAuthStore((state) => state.setAuthToken);
    const setUserProfile = useAuthStore((state) => state.setUserProfile);
    const { mutate: signupMutation } = useMutation({
        mutationKey: 'signup',
        mutationFn: (model) => signup(model),
        onSuccess: (data) => {
            setAuthToken(data.token);
            setUserProfile(data.profile);
            notifications.show({
                title: 'Success',
                message: 'Check your email for instructions',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return signupMutation;
};
export default useSignup;
